"use strict";
// import useSocket from '../../../hooks/useWebSocket';
// import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import { Howl, Howler } from "howler";
// import toast, { Toaster } from "react-hot-toast";
// import { Link } from 'react-router-dom';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RemorquageNotifications;
// interface RemorquageData {
//   id: number;
//   phone: string;
//   request_datetime: string;
//   lat: string;
//   long: string;
// }
// const AUDIO_KEY = "audioConsentV1";
// export default function RemorquageNotifications() {
//   const socket = useSocket();
//   const [lastNotification, setLastNotification] = useState<RemorquageData | null>(null);
//   const audioRef = useRef<HTMLAudioElement | null>(null);
//   const [showGate, setShowGate] = useState((localStorage.getItem(AUDIO_KEY) === "1") ? false : true);
//   const [consent, setConsent] = useState(localStorage.getItem(AUDIO_KEY) === "1");
//   console.log('audioKey', localStorage.getItem(AUDIO_KEY));
//   // Init audio + tentative d'autoplay si déjà consenti
//   useEffect(() => {
//     const el = audioRef.current;
//     if (!el) return;
//     // ton mp3 de notification
//     el.src = "/sounds/bell-notification.mp3"; // <-- change le chemin
//     el.preload = "auto";
//     el.loop = false;      // notif courte
//     el.volume = 1;        // ajuste si besoin
//     const stored = localStorage.getItem(AUDIO_KEY) === "1";
//     setConsent(stored);
//     if (stored) {
//       // Certains navigateurs laissent jouer si l’utilisateur a déjà interagi auparavant
//       // el.play().catch(() => {
//       //   // Si c’est bloqué, on attend un vrai geste (gate)
//       //   setShowGate(true);
//       // });
//     } else {
//       setShowGate(true);
//     }
//   }, []);
//   // Fonction centrale : essaie de jouer, sinon ouvre la “gate”
//   const playAlert = useCallback(async () => {
//     const el = audioRef.current;
//     if (!el) return false;
//     try {
//       await el.play();
//       setShowGate(false);
//       setConsent(true);
//       return true;
//     } catch {
//       if(!consent){
//         setShowGate(true);
//         return false;
//       }
//     }
//   }, []);
//   function safeToDate(input: unknown): Date | null {
//     if (input instanceof Date) return input;
//     if (typeof input === 'number') {
//       const d = new Date(input);
//       return isNaN(d.getTime()) ? null : d;
//     }
//     if (typeof input === 'string') {
//       const s = input.trim();
//       if (!s) return null;
//       // gère "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
//       const isoish = s.includes('T') ? s : s.replace(' ', 'T');
//       const d = new Date(isoish);
//       return isNaN(d.getTime()) ? null : d;
//     }
//     return null;
//   }
//   // util: formate en heure FR (HH:mm:ss)
//   function formatTime(d: Date) {
//     return new Intl.DateTimeFormat('fr-FR', {
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit'
//     }).format(d);
//   }
//   const handleNewRemorquage = useCallback((data: any) => {
//     setLastNotification(data);
//     console.log('data', data);
//     // 1) Normalise la payload
//     let payload = typeof data === 'string' ? JSON.parse(data) : data;
//     // 2) Vérifie ce que tu as réellement
//     console.log('typeof payload =', typeof payload, 'keys =', Object.keys(payload || {}));
//     // 3) Si c'est imbriqué, adapte ici (ex: payload.data)
//     let src = (payload as any)?.data ?? payload;
//     // 4) Récupère proprement
//     let phone = src?.phone ?? '';
//     let lat = src?.lat ?? null;
//     let long = src?.long ?? src?.long ?? null;
//     let request_datetime = src?.request_datetime ?? src?.request_datetime ?? null;
//     let slug = src?.slug ?? src?.slug ?? null;
//     console.log('vals:', phone, lat, long);
//     // Sécurise la date (essaie plusieurs champs possibles si dispo)
//     const rawDate = request_datetime;
//     const dateObj = safeToDate(rawDate) ?? new Date(); // fallback: maintenant
//     const timeLabel = formatTime(dateObj);
//     const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}`;
//     // const audio:any = document.getElementById('myAudio');
//     // audio.play().catch((err:any) => {
//     //     console.log('Lecture auto bloquée : ', err);
//     // });
//     // ⬇️ remplace l'ancien audio.play() par ceci :
//     playAlert().then((ok) => {
//       if (!ok && !consent) {
//         // Si bloqué, on propose d’activer le son directement depuis le toast
//         toast.custom((t) => (
//           <div style={{ background: "#000", color: "#fff", padding: 12, borderRadius: 8 }}>
//             Le son est bloqué par le navigateur.
//             <button
//               onClick={() => {
//                 // un clic utilisateur “réel” : on (re)tente, puis on mémorise
//                 playAlert().then((played) => {
//                   if (played) {
//                     localStorage.setItem(AUDIO_KEY, "1");
//                     setConsent(true);
//                     toast.dismiss(t.id);
//                   }
//                 });
//               }}
//               style={{
//                 marginLeft: 8,
//                 padding: "4px 8px",
//                 borderRadius: 6,
//                 border: 0,
//                 cursor: "pointer",
//               }}
//             >
//               Activer le son de notification
//             </button>
//           </div>
//         ), { duration: 6000 });
//       } else {
//         // si ça a joué, assurer la persistance
//         localStorage.setItem(AUDIO_KEY, "1");
//         setConsent(true);
//       }
//     });
//     toast.success(
//       (t) => (
//         // évite les clics involontaires sur tout le bloc quand on clique le bouton
//         <div onClick={() => handleNotificationClick(data)} style={{ cursor: 'pointer' }}>
//           Nouvelle demande SOS Remorquage du : {phone ?? '—'}
//           <br />
//           <small>{timeLabel}</small>
//           <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", flexWrap: "wrap"}}>
//             <Link 
//               to={`/admin/sos-remorquage/${slug}`}
//               onClick={(e) => {
//                 e.stopPropagation(); // évite handleNotificationClick
//                 toast.dismiss(t.id);
//               }}
//               style={{
//                 marginTop: 8,
//                 padding: '2px 8px',
//                 fontSize: '0.8rem',
//                 backgroundColor: '#009edb',
//                 color: 'white !important',
//                 border: 'none',
//                 borderRadius: 4,
//                 cursor: 'pointer',
//                 fontWeight: '700',
//               }}
//             >
//               Voir
//             </Link>
//             <a
//               href={googleMapsUrl}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="follow-position-link badge bg-success"
//               style={{ marginTop: 8, color: '#FFFFFF', textDecoration: 'none' }}
//               onClick={(e) => e.stopPropagation()} // ne pas déclencher le onClick parent
//             >
//               Suivre la position
//             </a>
//             <button
//               style={{
//                 marginTop: 8,
//                 padding: '2px 8px',
//                 fontSize: '0.8rem',
//                 backgroundColor: '#ff4d4f',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: 4,
//                 cursor: 'pointer',
//                 fontWeight: '700',
//               }}
//               onClick={(e) => {
//                 e.stopPropagation(); // évite handleNotificationClick
//                 toast.dismiss(t.id);
//               }}
//             >
//               Fermer
//             </button>
//           </div>
//         </div>
//       ),
//       {
//         duration: Infinity, // pas de fermeture auto
//         position: 'top-right'
//       }
//     );
//   }, [playAlert]);
//   // Initialisation des listeners
//   useEffect(() => {
//       if (!socket) return;
//       console.log('Initializing socket listeners...');
//       socket.emit('join', 'remorquage');
//       // Version corrigée du listener
//       const newRemorquageHandler = (data: RemorquageData) => {
//           console.log('Received new remorquage:', data);
//           handleNewRemorquage(data);
//       };
//       socket.on('new.remorquage', newRemorquageHandler);
//       // Nettoyage
//       return () => {
//           console.log('Cleaning up socket listeners...');
//           socket.off('new.remorquage', newRemorquageHandler);
//           socket.emit('leave', 'remorquage');
//       };
//   }, [socket, handleNewRemorquage]);
//   // Fonction de clic sur notification
//   const handleNotificationClick = (data: RemorquageData) => {
//       // Ajoutez votre logique de redirection ou d'action ici
//       console.log('Notification clicked', data);
//   };
//   return (
//     <>
//       {/* Lecteur caché */}
//       <audio ref={audioRef} style={{ display: "none" }} />
//       {/* Gate overlay (une seule fois puis mémorisé) */}
//       {showGate && (
//         <div
//           onClick={async () => {
//             const ok = await playAlert();
//             if (ok) {
//               localStorage.setItem(AUDIO_KEY, "1");
//               setConsent(true);
//             }
//           }}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,.6)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//             cursor: "pointer",
//           }}
//         >
//           <button
//             type="button"
//             onClick={async (e) => {
//               e.stopPropagation();
//               const ok = await playAlert();
//               if (ok) {
//                 localStorage.setItem(AUDIO_KEY, "1");
//                 setConsent(true);
//               }
//             }}
//             style={{
//               background: "#fff",
//               color: "#111",
//               border: 0,
//               borderRadius: 12,
//               padding: "10px 16px",
//               fontWeight: 700,
//             }}
//           >
//             Activer le son de notification
//           </button>
//         </div>
//       )}
//     </>
//   );
// }
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import toast from "react-hot-toast";
// import useSocket from "../../../hooks/useWebSocket";
// import useRealtimeChannel from "../../../hooks/useRealtimeChannel";
// interface RemorquageData {
//   id: number;
//   phone: string;
//   request_datetime: string;
//   lat: string;
//   long: string;
//   slug: string;
// }
// const AUDIO_KEY = "audioConsentV1";
// export default function RemorquageNotifications() {
//   const socket = useSocket();
//   const audioRef = useRef<HTMLAudioElement | null>(null);
//   const [consent, setConsent] = useState(localStorage.getItem(AUDIO_KEY) === "1");
//   const [showGate, setShowGate] = useState(!consent);
//   // 🎧 Initialisation audio
//   useEffect(() => {
//     const el = audioRef.current;
//     if (!el) return;
//     el.src = "/sounds/bell-notification.mp3";
//     el.preload = "auto";
//     el.loop = false;
//     el.volume = 1;
//     if (!consent) setShowGate(true);
//   }, [consent]);
//   // 🎵 Fonction pour jouer le son
//   const playAlert = useCallback(async (): Promise<boolean> => {
//     const el = audioRef.current;
//     if (!el) return false;
//     try {
//       await el.play();
//       setShowGate(false);
//       setConsent(true);
//       localStorage.setItem(AUDIO_KEY, "1");
//       return true;
//     } catch {
//       if (!consent) setShowGate(true);
//       return false;
//     }
//   }, [consent]);
//   // 🧭 utilitaires
//   const safeToDate = (input: unknown): Date | null => {
//     if (input instanceof Date) return input;
//     if (typeof input === "number") return new Date(input);
//     if (typeof input === "string") {
//       const iso = input.includes("T") ? input : input.replace(" ", "T");
//       const d = new Date(iso);
//       return isNaN(d.getTime()) ? null : d;
//     }
//     return null;
//   };
//   const formatTime = (d: Date) =>
//     new Intl.DateTimeFormat("fr-FR", {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//     }).format(d);
//   // 🧩 Fonction appelée à chaque nouvel événement
//   const handleNewRemorquage = useCallback(
//     (data: RemorquageData) => {
//       console.log("⚡ Nouvelle demande SOS reçue:", data);
//       const dateObj = safeToDate(data.request_datetime) ?? new Date();
//       const timeLabel = formatTime(dateObj);
//       const googleMapsUrl = `https://www.google.com/maps?q=${data.lat},${data.long}`;
//       // Essaye de jouer le son
//       playAlert().then((ok) => {
//         if (!ok && !consent) {
//           toast.custom(
//             (t) => (
//               <div style={{ background: "#000", color: "#fff", padding: 12, borderRadius: 8 }}>
//                 Le son est bloqué par le navigateur.
//                 <button
//                   onClick={() => {
//                     playAlert().then((played) => {
//                       if (played) {
//                         localStorage.setItem(AUDIO_KEY, "1");
//                         setConsent(true);
//                         toast.dismiss(t.id);
//                       }
//                     });
//                   }}
//                   style={{
//                     marginLeft: 8,
//                     padding: "4px 8px",
//                     borderRadius: 6,
//                     border: 0,
//                     cursor: "pointer",
//                   }}
//                 >
//                   Activer le son de notification
//                 </button>
//               </div>
//             ),
//             { duration: 6000 }
//           );
//         }
//       });
//       // ✅ Affiche la notification toast
//       toast.success(
//         (t) => (
//           <div style={{ cursor: "pointer" }}>
//             <strong>Nouvelle demande SOS Remorquage</strong>
//             <br />
//             {data.phone ?? "—"}
//             <br />
//             <small>{timeLabel}</small>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 gap: "5px",
//                 flexWrap: "wrap",
//                 marginTop: 8,
//               }}
//             >
//               <Link
//                 to={`/admin/sos-remorquage/${data.slug}`}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toast.dismiss(t.id);
//                 }}
//                 style={{
//                   padding: "2px 8px",
//                   fontSize: "0.8rem",
//                   backgroundColor: "#009edb",
//                   color: "white",
//                   border: "none",
//                   borderRadius: 4,
//                   cursor: "pointer",
//                   fontWeight: "700",
//                 }}
//               >
//                 Voir
//               </Link>
//               <a
//                 href={googleMapsUrl}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="badge bg-success"
//                 style={{
//                   color: "#FFFFFF",
//                   textDecoration: "none",
//                   padding: "2px 8px",
//                   fontSize: "0.8rem",
//                   borderRadius: 4,
//                   fontWeight: "700",
//                 }}
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 Suivre la position
//               </a>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toast.dismiss(t.id);
//                 }}
//                 style={{
//                   padding: "2px 8px",
//                   fontSize: "0.8rem",
//                   backgroundColor: "#ff4d4f",
//                   color: "white",
//                   border: "none",
//                   borderRadius: 4,
//                   cursor: "pointer",
//                   fontWeight: "700",
//                 }}
//               >
//                 Fermer
//               </button>
//             </div>
//           </div>
//         ),
//         { duration: Infinity, position: "top-right" }
//       );
//     },
//     [playAlert, consent]
//   );
//   // 🧠 Hook magique : souscription auto au channel remorquage
//   useRealtimeChannel<RemorquageData>({
//     socket,
//     channel: "remorquage",
//     event: "new.remorquage",
//     onMessage: handleNewRemorquage,
//   });
//   return (
//     <>
//       <audio ref={audioRef} style={{ display: "none" }} />
//       {showGate && (
//         <div
//           onClick={async () => {
//             const ok = await playAlert();
//             if (ok) {
//               localStorage.setItem(AUDIO_KEY, "1");
//               setConsent(true);
//             }
//           }}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,.6)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//             cursor: "pointer",
//           }}
//         >
//           <button
//             type="button"
//             onClick={async (e) => {
//               e.stopPropagation();
//               const ok = await playAlert();
//               if (ok) {
//                 localStorage.setItem(AUDIO_KEY, "1");
//                 setConsent(true);
//               }
//             }}
//             style={{
//               background: "#fff",
//               color: "#111",
//               border: 0,
//               borderRadius: 12,
//               padding: "10px 16px",
//               fontWeight: 700,
//             }}
//           >
//             Activer le son de notification
//           </button>
//         </div>
//       )}
//     </>
//   );
// }
const useWebSocket_1 = __importDefault(require("../../../hooks/useWebSocket"));
const useRealtimeChannel_1 = __importDefault(require("../../../hooks/useRealtimeChannel"));
const react_1 = __importStar(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const react_router_dom_1 = require("react-router-dom");
const AUDIO_KEY = "audioConsentV1";
function RemorquageNotifications() {
    const socket = (0, useWebSocket_1.default)();
    const [lastNotification, setLastNotification] = (0, react_1.useState)(null);
    const audioRef = (0, react_1.useRef)(null);
    const [showGate, setShowGate] = (0, react_1.useState)(localStorage.getItem(AUDIO_KEY) !== "1");
    const [consent, setConsent] = (0, react_1.useState)(localStorage.getItem(AUDIO_KEY) === "1");
    // Init audio + tentative d'autoplay si déjà consenti
    (0, react_1.useEffect)(() => {
        const el = audioRef.current;
        if (!el)
            return;
        el.src = "/sounds/bell-notification.mp3";
        el.preload = "auto";
        el.loop = false;
        el.volume = 1;
        const stored = localStorage.getItem(AUDIO_KEY) === "1";
        setConsent(stored);
        if (!stored)
            setShowGate(true);
    }, []);
    const playAlert = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const el = audioRef.current;
        if (!el)
            return false;
        try {
            yield el.play();
            setShowGate(false);
            setConsent(true);
            return true;
        }
        catch (_a) {
            if (!consent) {
                setShowGate(true);
                return false;
            }
        }
    }), [consent]);
    function safeToDate(input) {
        if (input instanceof Date)
            return input;
        if (typeof input === "number") {
            const d = new Date(input);
            return isNaN(d.getTime()) ? null : d;
        }
        if (typeof input === "string") {
            const s = input.trim();
            if (!s)
                return null;
            const isoish = s.includes("T") ? s : s.replace(" ", "T");
            const d = new Date(isoish);
            return isNaN(d.getTime()) ? null : d;
        }
        return null;
    }
    function formatTime(d) {
        return new Intl.DateTimeFormat("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).format(d);
    }
    const handleNotificationClick = (data) => {
        console.log("Notification clicked", data);
    };
    // 🔁 Remplace tout le useEffect socket précédent par useRealtimeChannel :
    (0, useRealtimeChannel_1.default)({
        socket,
        channel: "remorquage",
        event: "new.remorquage",
        onMessage: (data) => {
            var _a, _b, _c, _d, _e, _f, _g;
            setLastNotification(data);
            console.log("📡 Nouveau remorquage reçu:", data);
            const payload = typeof data === "string" ? JSON.parse(data) : data;
            const src = (_a = payload === null || payload === void 0 ? void 0 : payload.data) !== null && _a !== void 0 ? _a : payload;
            const phone = (_b = src === null || src === void 0 ? void 0 : src.phone) !== null && _b !== void 0 ? _b : "";
            const lat = (_c = src === null || src === void 0 ? void 0 : src.lat) !== null && _c !== void 0 ? _c : null;
            const long = (_d = src === null || src === void 0 ? void 0 : src.long) !== null && _d !== void 0 ? _d : null;
            const request_datetime = (_e = src === null || src === void 0 ? void 0 : src.request_datetime) !== null && _e !== void 0 ? _e : null;
            const slug = (_f = src === null || src === void 0 ? void 0 : src.slug) !== null && _f !== void 0 ? _f : null;
            const rawDate = request_datetime;
            const dateObj = (_g = safeToDate(rawDate)) !== null && _g !== void 0 ? _g : new Date();
            const timeLabel = formatTime(dateObj);
            const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}`;
            playAlert().then((ok) => {
                if (!ok && !consent) {
                    react_hot_toast_1.default.custom((t) => (react_1.default.createElement("div", { style: { background: "#000", color: "#fff", padding: 12, borderRadius: 8 } },
                        "Le son est bloqu\u00E9 par le navigateur.",
                        react_1.default.createElement("button", { onClick: () => {
                                playAlert().then((played) => {
                                    if (played) {
                                        localStorage.setItem(AUDIO_KEY, "1");
                                        setConsent(true);
                                        react_hot_toast_1.default.dismiss(t.id);
                                    }
                                });
                            }, style: {
                                marginLeft: 8,
                                padding: "4px 8px",
                                borderRadius: 6,
                                border: 0,
                                cursor: "pointer",
                            } }, "Activer le son de notification"))), { duration: 6000 });
                }
                else {
                    localStorage.setItem(AUDIO_KEY, "1");
                    setConsent(true);
                }
            });
            react_hot_toast_1.default.success((t) => (react_1.default.createElement("div", { onClick: () => handleNotificationClick(data), style: { cursor: "pointer" } },
                "Nouvelle demande SOS Remorquage du : ", phone !== null && phone !== void 0 ? phone : "—",
                react_1.default.createElement("br", null),
                react_1.default.createElement("small", null, timeLabel),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "5px",
                        flexWrap: "wrap",
                    } },
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/admin/sos-remorquage/${slug}`, onClick: (e) => {
                            e.stopPropagation();
                            react_hot_toast_1.default.dismiss(t.id);
                        }, style: {
                            marginTop: 8,
                            padding: "2px 8px",
                            fontSize: "0.8rem",
                            backgroundColor: "#009edb",
                            color: "white !important",
                            border: "none",
                            borderRadius: 4,
                            cursor: "pointer",
                            fontWeight: "700",
                        } }, "Voir"),
                    react_1.default.createElement("a", { href: googleMapsUrl, target: "_blank", rel: "noopener noreferrer", className: "follow-position-link badge bg-success", style: { marginTop: 8, color: "#FFFFFF", textDecoration: "none" }, onClick: (e) => e.stopPropagation() }, "Suivre la position"),
                    react_1.default.createElement("button", { style: {
                            marginTop: 8,
                            padding: "2px 8px",
                            fontSize: "0.8rem",
                            backgroundColor: "#ff4d4f",
                            color: "white",
                            border: "none",
                            borderRadius: 4,
                            cursor: "pointer",
                            fontWeight: "700",
                        }, onClick: (e) => {
                            e.stopPropagation();
                            react_hot_toast_1.default.dismiss(t.id);
                        } }, "Fermer")))), {
                duration: Infinity,
                position: "top-right",
            });
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("audio", { ref: audioRef, style: { display: "none" } }),
        showGate && (react_1.default.createElement("div", { onClick: () => __awaiter(this, void 0, void 0, function* () {
                const ok = yield playAlert();
                if (ok) {
                    localStorage.setItem(AUDIO_KEY, "1");
                    setConsent(true);
                }
            }), style: {
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                cursor: "pointer",
            } },
            react_1.default.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    const ok = yield playAlert();
                    if (ok) {
                        localStorage.setItem(AUDIO_KEY, "1");
                        setConsent(true);
                    }
                }), style: {
                    background: "#fff",
                    color: "#111",
                    border: 0,
                    borderRadius: 12,
                    padding: "10px 16px",
                    fontWeight: 700,
                } }, "Activer le son de notification")))));
}
